/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Realtime Schema Projection
 * Frontend-only aliases for realtime payload validation.
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {RealtimeResourceChange} from "./realtimeResourceChange.zod";

export const LeadRealtimeChange = RealtimeResourceChange.and(
  zod.object({
    resource: zod.enum(["sales.leads"]),
    resourceId: zod.uuid(),
    change: zod.enum(["CREATED", "UPDATED", "DELETED", "RESTORED"]),
  }),
);

export type LeadRealtimeChange = zod.input<typeof LeadRealtimeChange>;
export type LeadRealtimeChangeOutput = zod.output<typeof LeadRealtimeChange>;
